import Phaser from "phaser";
import { STORY_BIOMES, STORY_CONFIG, getStoryBiomeProfile, type StoryBiomeId } from "../story/storyConfig";

export class BiomeRhythmSystem {
  static pickBiome(elapsed: number): StoryBiomeId {
    const progress = Phaser.Math.Clamp(elapsed / STORY_CONFIG.songDurationSeconds, 0, 0.999);
    const index = Math.min(STORY_BIOMES.length - 1, Math.floor(progress * STORY_BIOMES.length));
    return STORY_BIOMES[index];
  }

  static getProfile(id: StoryBiomeId) {
    return getStoryBiomeProfile(id);
  }
}
